import React from "react";
import { Container } from "react-bootstrap";

export default function Report() {
  return (
    <section className="Museums-main position-relative">
      <div className="overlay-gra"></div>
      <Container>
        <div className="banner-head">
          <h1>Newsletter Signup</h1>
        </div>
      </Container>
    </section>
  );
}
